import Http from "../../common/utils/Http";

export const givePayCardList = async () => {
    try {
        return await Http.get('home/content/give');
    } catch (error) {
        throw error;
    }
}
